/**
 * Admin içerik/kategori listeleri için A→Z, Z→A, tarih (yeni/eski) sıralama.
 * Ad sıralamasında sayı blokları doğal sırada değerlendirilir (örn. ...-25 önce ...-100).
 * URL: ?sira=ad-az | ad-za | tarih-yeni | tarih-eski
 */

export const LIST_SORT_DEFAULT = 'ad-az';

export const LIST_SORT_OPTIONS = [
  { value: 'ad-az', label: 'A → Z' },
  { value: 'ad-za', label: 'Z → A' },
  { value: 'tarih-yeni', label: 'En yeni' },
  { value: 'tarih-eski', label: 'En eski' },
];

const VALID = new Set(LIST_SORT_OPTIONS.map((o) => o.value));

/**
 * @param {string | null | undefined} value
 * @returns {string} one of LIST_SORT_OPTIONS values; invalid → ad-az
 */
export function parseListSortParam(value) {
  const v = value == null ? '' : String(value).trim();
  if (VALID.has(v)) return v;
  return LIST_SORT_DEFAULT;
}

const LOCALE = 'tr';
/** Türkçe, büyük/küçük harf nötrü, sayılı metinlerde doğal sıra (ÜKY/Y-25 < ÜKY/Y-100). */
const LOCALE_COMPARE_OPTS = { sensitivity: 'base', numeric: true };

function categoryName(c) {
  const n = c?.kategoriAdi;
  return n != null && String(n).trim() !== '' ? String(n) : '';
}

function contentSortName(item) {
  if (!item) return '';
  return (
    item.icerikAdi ||
    item.urunAdi ||
    item.parcaAdi ||
    item.islemAdi ||
    item.arizaAdi ||
    item.ad ||
    ''
  );
}

function createdMs(row) {
  const d = row?.olusturmaTarihi;
  if (d == null) return 0;
  const t = new Date(d).getTime();
  return Number.isFinite(t) ? t : 0;
}

/**
 * @param {object} a
 * @param {object} b
 * @param {string} mode parseListSortParam result
 * @returns {number}
 */
export function compareCategories(a, b, mode) {
  if (mode === 'ad-za') {
    return compareCategories(b, a, 'ad-az');
  }
  if (mode === 'tarih-yeni' || mode === 'tarih-eski') {
    const da = createdMs(a);
    const dbb = createdMs(b);
    if (da !== dbb) {
      return mode === 'tarih-yeni' ? dbb - da : da - dbb;
    }
    return categoryName(a).localeCompare(categoryName(b), LOCALE, LOCALE_COMPARE_OPTS);
  }
  // ad-az
  const ca = categoryName(a).localeCompare(categoryName(b), LOCALE, LOCALE_COMPARE_OPTS);
  if (ca !== 0) return ca;
  return createdMs(a) - createdMs(b);
}

/**
 * Hiyerarşik ağaç: her seviyede kardeşleri sıralar (yerinde).
 * @param {Array} rootNodes buildCategoryTree çıktısı
 * @param {string} mode
 */
export function sortCategoryTreeSiblings(rootNodes, mode) {
  if (!Array.isArray(rootNodes) || rootNodes.length === 0) return;
  const walk = (nodes) => {
    nodes.sort((a, b) => compareCategories(a, b, mode));
    nodes.forEach((n) => {
      if (n.children && n.children.length) walk(n.children);
    });
  };
  walk(rootNodes);
}

/**
 * @param {object} a
 * @param {object} b
 * @param {string} mode
 * @returns {number}
 */
export function compareContents(a, b, mode) {
  if (mode === 'ad-za') {
    return compareContents(b, a, 'ad-az');
  }
  if (mode === 'tarih-yeni' || mode === 'tarih-eski') {
    const da = createdMs(a);
    const dbb = createdMs(b);
    if (da !== dbb) {
      return mode === 'tarih-yeni' ? dbb - da : da - dbb;
    }
    return String(contentSortName(a)).localeCompare(String(contentSortName(b)), LOCALE, LOCALE_COMPARE_OPTS);
  }
  const c = String(contentSortName(a)).localeCompare(String(contentSortName(b)), LOCALE, LOCALE_COMPARE_OPTS);
  if (c !== 0) return c;
  return createdMs(a) - createdMs(b);
}

/**
 * Yeni dizi döner; orijinali değiştirmez.
 * @param {Array} rows
 * @param {string} mode
 * @returns {Array}
 */
export function sortContentsRows(rows, mode) {
  if (!Array.isArray(rows) || rows.length === 0) return rows || [];
  return [...rows].sort((a, b) => compareContents(a, b, mode));
}
